import { FaUserCircle } from "react-icons/fa";
import { ActiveIcon, InactiveIcon } from "../../../assets/svg/icons";
import { BASE_URL } from "../../../constants/apiConstants";
import { translateAgeString } from "../../../utils/exportUtils";
import { useTranslation } from "react-i18next";
import { StudentStatusTag } from "./StudentStatusTag";


export const renderCellContent = (col, row, page) => {
  const key = col;
  const showImage = key === "name" || key === "room";
  const hasImage = !!row.image;
  const text = row[key];

  if (key === "age") {
    return translateAgeString(text);
  }

  if (showImage) {
    return (
      <div className="d-flex align-items-center gap-2">
        {hasImage ? (
          <img
            src={row.image?.startsWith('http') ? row.image : BASE_URL + row.image}
            alt={row.name}
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
            }}
          />
        ) : key === "name" ? (
          <FaUserCircle size={24} />
        ) : null}
        <span className="cursor-pointer">{text}</span>
      </div>
    );
  }
  if (key === "status" && page === "student") {
   return <StudentStatusTag value={text} />;
  }

  return text;
};
